<!-- the footer. todo: use modal service instead of this app-modal technique -->
<ng-container *ngIf="!machine.buyItNowOnly">
  <div class="add-to-cart-footer d-block d-xl-none fixed-bottom">
    <div class="d-flex">
      <!-- <div class="negative-margin">
        <div class="price-container">
          <h2 class="price"><span class="currency-symbol align-text-top">$</span>{{ machine.rateSchedules[1].cost | thousandSuffix: 1 }}</h2>
        </div>
        <div class="d-flex align-items-center">
          <p class="per-month-text">per week</p>
        </div>
      </div> -->
      <div class="margin-right">
        <button
          type="button"
          class="btn btn-no-box-shadow add-to-cart-button"
          [class.btn-primary]="!machineInCart"
          [class.btn-secondary]="machineInCart"
          (click)="machineInCart ? editCartItem(cartItem) : addToCart()"
          [disabled]="machine.status != 'Available' && machine.status != 'Onboarding'"
        >
          {{ buttonText() }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
